var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFavorites = function SvgFavorites(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.88 8.928-7.065 7.028h-.3L1.943 8.512l.01-.005a5.127 5.127 0 0 1-1.3-3.421A4.931 4.931 0 0 1 5.473.05 4.776 4.776 0 0 1 9.69 2.697 4.745 4.745 0 0 1 13.893.044a4.9 4.9 0 0 1 4.787 5 5.055 5.055 0 0 1-1.8 3.884Zm-1.276-1.6L9.78 13.252h-.245l-6.11-6.208.017-.02a2.989 2.989 0 1 1 4.621-3.78l.008-.007.037.058c.08.115.153.235.216.36l1.392 2.323 1.275-2.239c.066-.143.144-.28.232-.41A2.993 2.993 0 1 1 15.6 7.332l.004-.004Z",
    fill: "#C4C4C4"
  })));
};
export default SvgFavorites;